export default __webpack_public_path__ + "static/media/icon-new-window.eecd467c.svg";